import React, { useEffect, useMemo, useRef, useState } from 'react';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
export type LocaleType = 'en-US' | 'zh-CN';

export type SingleCommonType = {
  onChange?: (
    value: string,
    data: any,
    deleteKey?: string | Array<string> | null,
  ) => void;
  defaultValue?: any;
  filterValue?: any;
  defaultKey?: any;
  filterOptions?: any;
  lang: LocaleType;
  noLimitation?: boolean;
  setConfirmDisable?: (value: boolean) => void;
};

export const logicTextMap: any = {
  and: {
    'en-US': 'and',
    'zh-CN': '且',
    type: 'init-join',
    // tips: andText,
  },
  or: {
    'en-US': 'or',
    'zh-CN': '或',
    type: 'all-join',
    // tips: orText,
  },
};

// 情报公共逻辑或、与组件
export default function LogicSelectBtn(props: any) {
  const { logicType = 'and' } = props;

  const { locale } = useIntlExtend();

  const logic = logicTextMap[logicType as 'or' | 'and'];

  return (
    <div className="dbi-logic-select-btn">
      <div className="dbi-logic-select">
        <SvgIcon type={logic.type} className="dbi-logic-select-icon" />
        <span>{logic[locale]}</span>
      </div>
    </div>
  );
}
